import { Button, Modal, Card, ListGroup } from 'react-bootstrap';
import { useIntl } from 'react-intl';

interface ISurveyProps {
  survey: ISurvey;
}

const Questionnaire = ({ survey }: ISurveyProps) => {
  const intl = useIntl();

  const questions: IQuestion[] = [];
  for (const page of survey.pages) {
    questions.push(...page.questions);
  }
  const questionsWithTitle = questions.filter((question) => question.title);

  return (
    <Card>
      <Card.Header className="d-inline-flex align-items-center h-100 w-100">
        <span data-test="preview-questionnaire-title" className="pe-4">
          {intl.formatMessage({ id: survey.title })}
        </span>
      </Card.Header>

      {questionsWithTitle.length > 0 && (
        <Card.Body data-test="preview-questionnaire-questions">
          <ListGroup variant="flush">
            {questionsWithTitle.map((question, index) => (
              <ListGroup.Item
                data-test={`preview-questionnaire-question-${index}`}
                key={question.question_id}
              >
                {question.title && intl.formatMessage({ id: question.title })}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      )}
    </Card>
  );
};

interface IMessagingSurveyProps {
  show: boolean;
  handleClose: any;
  questionnaire: ISurvey;
}

const PreviewQuestionnaireModal = ({ show, handleClose, questionnaire }: IMessagingSurveyProps) => {
  const intl = useIntl();

  return (
    <Modal
      data-test="preview-questionnaire-modal"
      show={show}
      onHide={handleClose}
      contentClassName="addSurveyModalContainer"
    >
      <Modal.Header closeButton>
        <Modal.Title data-test="preview-questionnaire-modal-title">
          {`${intl.formatMessage({ id: 'questionnaireKey' })} ${intl.formatMessage({
            id: 'previewKey'
          })}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-auto">
        <Questionnaire survey={questionnaire} />
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-test="preview-questionnaire-modal-close-btn"
          variant="link"
          onClick={handleClose}
        >
          {intl.formatMessage({ id: 'closeKey' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewQuestionnaireModal;
